import { largeDecimalFormat } from 'common/formats/formats';
import { ParserParams } from 'models/interfaces/spreadsheet-types/core-types';
import commonInvestmentParser from '../../commonInvestmentParser';
import { FundInvestmentColumn } from '../useFundInvestmentSheetConfig/useFundInvestmentSheetConfig.types';

const fundInvestmentParser = (params: ParserParams<FundInvestmentColumn, object, object, object>) =>
  commonInvestmentParser({
    ...params,
    options: {
      useValueDirectly: true,
      shareCountFormat: largeDecimalFormat,
      lastRowFirstColumnFormat: largeDecimalFormat,
    },
  });

export default fundInvestmentParser;
